export default __webpack_public_path__ + "static/media/riso-9.3e475efa.jpg";